// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldNumberOutlinedSvg from "@fishx/icons-svg/es/asn/FieldNumberOutlined";
import FishxIcon from '../components/FishxIcon';

var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldNumberOutlinedSvg
  }));
};

FieldNumberOutlined.displayName = 'FieldNumberOutlined';
export default React.forwardRef(FieldNumberOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FieldNumberOutlined.js
// module id = 2673
// module chunks = 0